"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How does the ClifRock panel system reduce labor costs?",
  answer: "Our pre-cast fiber-reinforced concrete panels eliminate the need for heavy machinery and traditional masonry footings. A small crew can install a full outdoor kitchen or water feature in a fraction of the time it takes for traditional stone-and-mortar construction."
}, {
  question: "What kind of training do you provide for new installers?",
  answer: "We offer comprehensive hands-on training, webinars, and on-site support. Our goal is to ensure your team is proficient in the panel masonry system, from design and sales to final installation and finishing techniques."
}, {
  question: "Can ClifRock panels withstand extreme weather conditions?",
  answer: "Yes, our panels are engineered for durability in all climates. They are freeze-thaw stable, heat-resistant, and designed to maintain their structural integrity and aesthetic appeal through harsh winters and intense summer sun."
}, {
  question: "What marketing and sales tools are available to partners?",
  answer: "Installers gain access to our professional project gallery, design resources, co-branded marketing materials, and lead generation support to help you close more high-end outdoor living projects."
}, {
  question: "How do I become an authorized ClifRock installer?",
  answer: "The process starts with an application. Once reviewed, we'll discuss the opportunity in your territory and schedule your initial training session to get you certified and ready to build."
}];
export default function CommonQuestions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll();
  return <section data-section-id="256841" id="common-questions" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-700 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground font-default mb-4 tracking-tight">
            Common Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Everything you need to know about the ClifRock panel masonry system and our installer network.
          </p>
        </div>

        <div ref={listRef} className={`transition-all duration-700 delay-200 ${isListVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-lg bg-card px-4 md:px-6 shadow-sm data-[state=open]:shadow-md transition-all duration-200">
                <AccordionTrigger className="group [&>svg:last-child]:hidden hover:no-underline py-6">
                  <span className="text-base md:text-lg font-semibold text-foreground font-default text-left pr-4">
                    {faq.question}
                  </span>
                  <div className="shrink-0 text-primary relative flex items-center justify-center size-8 rounded-md border border-primary/20 bg-primary/5 group-data-[state=open]:bg-primary group-data-[state=open]:text-primary-foreground transition-colors duration-300">
                    <Plus className="size-4 absolute transition-all duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                    <Minus className="size-4 absolute transition-all duration-300 -rotate-90 opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base pb-6 leading-relaxed pr-12 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>

          <div className="mt-16 text-center pt-8 border-t border-border">
            <p className="text-muted-foreground font-default mb-4">
              Still have questions? We're here to help you grow your business.
            </p>
            <a href="tel:1-800-CLIFROCK" className="text-primary font-bold text-xl hover:text-secondary transition-colors duration-300 font-default">
              Call 1-800-CLIFROCK
            </a>
          </div>
        </div>
      </div>
    </section>;
}